import {
  useWSModalCustom,
  WSForm,
  WSList,
  WSModal,
  WSModalCustomProps,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import * as Yup from "yup";
import {
  CategoryPickerField,
  CategoryPickerValue
} from "../components/CategoryPicker";

type FormData = { category: CategoryPickerValue };

type Props = { count: number } & WSModalCustomProps<CategoryPickerValue>;

const ModalBulkUpdateCategory: React.FC<Props> = props => {
  return (
    <WSForm<FormData>
      onSubmit={formData => props.onClose(formData.category)}
      defaultValues={{ category: {} }}
      validationSchema={Yup.object().shape({
        category: Yup.object().test(
          "has-category",
          "Required",
          value => !!(value as CategoryPickerValue)?.wsCategory
        )
      })}
    >
      <WSModal
        title="Update category"
        size="S"
        onClose={props.onClose}
        actions={{
          buttons: [
            {
              label: "Cancel",
              kind: "Secondary",
              type: "button",
              onClick: () => props.onClose({})
            },
            { label: `Update ${props.count}` }
          ]
        }}
      >
        <WSList gap="M">
          <WSText color="gray500">
            Set the same category on the {props.count} selected transactions.
          </WSText>
          <WSForm.Field
            name="category"
            label="Category"
            component={CategoryPickerField}
          />
        </WSList>
      </WSModal>
    </WSForm>
  );
};

export const useModalBulkUpdateCategory = () =>
  useWSModalCustom(ModalBulkUpdateCategory);
